import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpErrorResponse,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from "rxjs";
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from "@angular/router";
import 'rxjs/add/operator/do';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    private spinner: NgxSpinnerService,
    public router: Router,
  ) {}
  intercept(
      request: HttpRequest<any>,
      next: HttpHandler
    ): Observable<HttpEvent<any>> {
    this.spinner.show();
    if(localStorage.getItem('adminDetails')) {
      let adminDetails = JSON.parse(localStorage.getItem('adminDetails'));
      request = request.clone({
        setHeaders: {
          Authorization: adminDetails.accessToken
        }
      });
    }
    //return next.handle(request);
    return next.handle(request).do(
      (event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.spinner.hide();
        }
      },
      (err: any) => {
        console.log("err.error.status", err.error);
        if (err.error.status == 401) {
          this.spinner.hide();
          localStorage.removeItem('adminDetails');
          this.router.navigate(['/login']);
        }
        if (err instanceof HttpErrorResponse) {
          this.spinner.hide();
        }
      }
    );
  }
}
